// @component ./TabBottom.tsx
export { default as Bottom } from './TabBottom'
